
// src/actions/chat-rooms.js

import api from './gamba-api'
import { emitAlertMessage, clearAlertMessage } from './alert-message'

export const FETCH_CHAT_ROOMS_LENGTH = 10

export const FETCH_CHAT_ROOMS = "FETCH_CHAT_ROOMS"
export const FETCH_CHAT_ROOMS_REQUESTED = "FETCH_CHAT_ROOMS_REQUESTED"
export const FETCH_CHAT_ROOMS_COMPLETED = "FETCH_CHAT_ROOMS_COMPLETED"
export const FETCH_CHAT_ROOMS_FAILED = "FETCH_CHAT_ROOMS_FAILED"

export function fetchChatRoomsRequested() {
  return {
    type: FETCH_CHAT_ROOMS_REQUESTED
  }
}

export function fetchChatRooms(offset) {
  return function(dispatch) {
    dispatch(fetchChatRoomsRequested())
    return api.get(`/chat_rooms`, { offset, length: FETCH_CHAT_ROOMS_LENGTH })
        .then((results)=> {
          dispatch(fetchChatRoomsCompleted(results, offset))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchChatRoomsFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchChatRoomsCompleted(results, offset) {
  return {
    type: FETCH_CHAT_ROOMS_COMPLETED,
    results, offset
  }
}

export function fetchChatRoomsFailed(error) {
  return {
    type: FETCH_CHAT_ROOMS_FAILED,
    error,
  }
}

export const CREATE_CHAT_ROOM = "CREATE_CHAT_ROOM"
export const CREATE_CHAT_ROOM_REQUESTED = "CREATE_CHAT_ROOM_REQUESTED"
export const CREATE_CHAT_ROOM_COMPLETED = "CREATE_CHAT_ROOM_COMPLETED"
export const CREATE_CHAT_ROOM_FAILED = "CREATE_CHAT_ROOM_FAILED"

export function createChatRoomRequested() {
  return {
    type: CREATE_CHAT_ROOM_REQUESTED
  }
}

export function createChatRoom(users) {
  return function(dispatch) {
    dispatch(createChatRoomRequested())
    return api.post(`/chat_rooms`, { users })
        .then((results)=> {
          dispatch(createChatRoomCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(createChatRoomFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function createChatRoomCompleted(results) {
  return {
    type: CREATE_CHAT_ROOM_COMPLETED,
    results,
  }
}

export function createChatRoomFailed(error) {
  return {
    type: CREATE_CHAT_ROOM_FAILED,
    error,
  }
}

export const FETCH_CHAT_ROOM = "FETCH_CHAT_ROOM"
export const FETCH_CHAT_ROOM_REQUESTED = "FETCH_CHAT_ROOM_REQUESTED"
export const FETCH_CHAT_ROOM_COMPLETED = "FETCH_CHAT_ROOM_COMPLETED"
export const FETCH_CHAT_ROOM_FAILED = "FETCH_CHAT_ROOM_FAILED"

export function fetchChatRoomRequested() {
  return {
    type: FETCH_CHAT_ROOM_REQUESTED
  }
}

export function fetchChatRoom(chat_room_id) {
  return function(dispatch) {
    dispatch(fetchChatRoomRequested())
    return api.get(`/chat_rooms/${chat_room_id}`)
        .then((results)=> {
          dispatch(fetchChatRoomCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchChatRoomFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchChatRoomCompleted(results) {
  return {
    type: FETCH_CHAT_ROOM_COMPLETED,
    results,
  }
}

export function fetchChatRoomFailed(error) {
  return {
    type: FETCH_CHAT_ROOM_FAILED,
    error,
  }
}

export const FETCH_CHAT_ROOM_UNREAD_COUNT = "FETCH_CHAT_ROOM_UNREAD_COUNT"
export const FETCH_CHAT_ROOM_UNREAD_COUNT_REQUESTED = "FETCH_CHAT_ROOM_UNREAD_COUNT_REQUESTED"
export const FETCH_CHAT_ROOM_UNREAD_COUNT_COMPLETED = "FETCH_CHAT_ROOM_UNREAD_COUNT_COMPLETED"
export const FETCH_CHAT_ROOM_UNREAD_COUNT_FAILED = "FETCH_CHAT_ROOM_UNREAD_COUNT_FAILED"

export function fetchChatRoomUnreadCountRequested() {
  return {
    type: FETCH_CHAT_ROOM_UNREAD_COUNT_REQUESTED
  }
}

export function fetchChatRoomUnreadCount(page) {
  return function(dispatch) {
    dispatch(fetchChatRoomUnreadCountRequested())
    return api.get(`/chat_rooms/unread_count`)
        .then((results)=> {
          dispatch(fetchChatRoomUnreadCountCompleted(results))
          if(page && results.unread_count){
            dispatch(emitAlertMessage(`${results.unread_count }件の新着メッセージが届いています。`, 'messageAlert'))
          }
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchChatRoomUnreadCountFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchChatRoomUnreadCountCompleted(results) {
  return {
    type: FETCH_CHAT_ROOM_UNREAD_COUNT_COMPLETED,
    results,
  }
}

export function fetchChatRoomUnreadCountFailed(error) {
  return {
    type: FETCH_CHAT_ROOM_UNREAD_COUNT_FAILED,
    error,
  }
}

export const CLEAR_CHAT_ROOM_UNREAD_COUNT = "CLEAR_CHAT_ROOM_UNREAD_COUNT"

export function clearChatRoomUnreadCount() {
  return {
    type: CLEAR_CHAT_ROOM_UNREAD_COUNT
  }
}

export const DELETE_CHAT_ROOM = "DELETE_CHAT_ROOM"
export const DELETE_CHAT_ROOM_REQUESTED = "DELETE_CHAT_ROOM_REQUESTED"
export const DELETE_CHAT_ROOM_COMPLETED = "DELETE_CHAT_ROOM_COMPLETED"
export const DELETE_CHAT_ROOM_FAILED = "DELETE_CHAT_ROOM_FAILED"

export function deleteChatRoomRequested() {
  return {
    type: DELETE_CHAT_ROOM_REQUESTED
  }
}

export function deleteChatRoom(chat_room_id) {
  return function(dispatch) {
    dispatch(deleteChatRoomRequested())
    return api.delete(`/chat_rooms/${chat_room_id}`)
        .then((results)=> {
          dispatch(deleteChatRoomCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(deleteChatRoomFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function deleteChatRoomCompleted(results) {
  return {
    type: DELETE_CHAT_ROOM_COMPLETED,
    results,
  }
}

export function deleteChatRoomFailed(error) {
  return {
    type: DELETE_CHAT_ROOM_FAILED,
    error,
  }
}

export const JOIN_CHAT_ROOM = "JOIN_CHAT_ROOM"
export const JOIN_CHAT_ROOM_REQUESTED = "JOIN_CHAT_ROOM_REQUESTED"
export const JOIN_CHAT_ROOM_COMPLETED = "JOIN_CHAT_ROOM_COMPLETED"
export const JOIN_CHAT_ROOM_FAILED = "JOIN_CHAT_ROOM_FAILED"

export function joinChatRoomRequested() {
  return {
    type: JOIN_CHAT_ROOM_REQUESTED
  }
}

export function joinChatRoom(chat_room_id, user_id) {
  return function(dispatch) {
    dispatch(joinChatRoomRequested())
    return api.put(`/chat_rooms/${chat_room_id}`, { user_id, mode: 'join' })
        .then((results)=> {
          dispatch(joinChatRoomCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(joinChatRoomFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function joinChatRoomCompleted(results) {
  return {
    type: JOIN_CHAT_ROOM_COMPLETED,
    results,
  }
}

export function joinChatRoomFailed(error) {
  return {
    type: JOIN_CHAT_ROOM_FAILED,
    error,
  }
}

export const LEAVE_CHAT_ROOM = "LEAVE_CHAT_ROOM"
export const LEAVE_CHAT_ROOM_REQUESTED = "LEAVE_CHAT_ROOM_REQUESTED"
export const LEAVE_CHAT_ROOM_COMPLETED = "LEAVE_CHAT_ROOM_COMPLETED"
export const LEAVE_CHAT_ROOM_FAILED = "LEAVE_CHAT_ROOM_FAILED"

export function leaveChatRoomRequested() {
  return {
    type: LEAVE_CHAT_ROOM_REQUESTED
  }
}

export function leaveChatRoom(chat_room_id, user_id) {
  return function(dispatch) {
    dispatch(leaveChatRoomRequested())
    return api.put(`/chat_rooms/${chat_room_id}`, { user_id, mode: 'leave' })
        .then((results)=> {
          dispatch(leaveChatRoomCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(leaveChatRoomFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function leaveChatRoomCompleted(results) {
  return {
    type: LEAVE_CHAT_ROOM_COMPLETED,
    results,
  }
}

export function leaveChatRoomFailed(error) {
  return {
    type: LEAVE_CHAT_ROOM_FAILED,
    error,
  }
}

export const UPDATE_CHAT_ROOM = "UPDATE_CHAT_ROOM"
export const UPDATE_CHAT_ROOM_REQUESTED = "UPDATE_CHAT_ROOM_REQUESTED"
export const UPDATE_CHAT_ROOM_COMPLETED = "UPDATE_CHAT_ROOM_COMPLETED"
export const UPDATE_CHAT_ROOM_FAILED = "UPDATE_CHAT_ROOM_FAILED"

export function updateChatRoomRequested() {
  return {
    type: UPDATE_CHAT_ROOM_REQUESTED
  }
}

export function updateChatRoom(chat_room_id, name, uploadable_file_id, crop) {
  return function(dispatch) {
    dispatch(updateChatRoomRequested())
    return api.put(`/chat_rooms/${chat_room_id}`, { name, mode: 'update', uploadable_file_id, crop })
        .then((results)=> {
          dispatch(updateChatRoomCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(updateChatRoomFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function updateChatRoomCompleted(results) {
  return {
    type: UPDATE_CHAT_ROOM_COMPLETED,
    results,
  }
}

export function updateChatRoomFailed(error) {
  return {
    type: UPDATE_CHAT_ROOM_FAILED,
    error,
  }
}

export const CLEAR_CHAT_ROOMS = "CLEAR_CHAT_ROOMS"

export function clearChatRooms() {
  return {
    type: CLEAR_CHAT_ROOMS
  }
}

export const EXCLUDE_CHAT_ROOM = "EXCLUDE_CHAT_ROOM"
export const EXCLUDE_CHAT_ROOM_REQUESTED = "EXCLUDE_CHAT_ROOM_REQUESTED"
export const EXCLUDE_CHAT_ROOM_COMPLETED = "EXCLUDE_CHAT_ROOM_COMPLETED"
export const EXCLUDE_CHAT_ROOM_FAILED = "EXCLUDE_CHAT_ROOM_FAILED"

export function excludeChatRoomRequested() {
  return {
    type: EXCLUDE_CHAT_ROOM_REQUESTED
  }
}

export function excludeChatRoom(chat_room_id, user_id) {
  return function(dispatch) {
    dispatch(excludeChatRoomRequested())
    return api.put(`/chat_rooms/${chat_room_id}`, { user_id, mode: 'leave' })
        .then((results)=> {
          dispatch(excludeChatRoomCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(excludeChatRoomFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function excludeChatRoomCompleted(results) {
  return {
    type: EXCLUDE_CHAT_ROOM_COMPLETED,
    results,
  }
}

export function excludeChatRoomFailed(error) {
  return {
    type: EXCLUDE_CHAT_ROOM_FAILED,
    error,
  }
}

export const LOAD_CHAT_ROOM = "LOAD_CHAT_ROOM"

export function loadChatRoom(chat_room, deleted) {
  return {
    type: LOAD_CHAT_ROOM,
    chat_room,
    deleted,
  }
}

export const LOAD_CHAT_ROOM_UNREAD_COUNT = "LOAD_CHAT_ROOM_UNREAD_COUNT"

export function loadChatRoomUnreadCount(unread_count) {
  return {
    type: LOAD_CHAT_ROOM_UNREAD_COUNT,
    unread_count
  }
}

export const FETCH_ALBUM_LENGTH = 20

export const FETCH_ALBUM_CHAT_IMAGE = "FETCH_ALBUM_CHAT_IMAGE"
export const FETCH_ALBUM_CHAT_IMAGE_REQUESTED = "FETCH_ALBUM_CHAT_IMAGE_REQUESTED"
export const FETCH_ALBUM_CHAT_IMAGE_COMPLETED = "FETCH_ALBUM_CHAT_IMAGE_COMPLETED"
export const FETCH_ALBUM_CHAT_IMAGE_FAILED = "FETCH_ALBUM_CHAT_IMAGE_FAILED"

export function fetchAlbumChatImageRequested() {
  return {
    type: FETCH_ALBUM_CHAT_IMAGE_REQUESTED
  }
}

export function fetchAlbumChatImage(chat_room_id, file_type, offset) {
  return function(dispatch) {
    dispatch(fetchAlbumChatImageRequested())
    return api.get(`/chat_rooms/${chat_room_id}/files`, { file_type, offset, length: FETCH_ALBUM_LENGTH })
        .then((results)=> {
          dispatch(fetchAlbumChatImageCompleted(results, file_type, offset))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchAlbumChatImageFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchAlbumChatImageCompleted(results, file_type, offset) {
  return {
    type: FETCH_ALBUM_CHAT_IMAGE_COMPLETED,
    results, file_type, offset,
  }
}

export function fetchAlbumChatImageFailed(error) {
  return {
    type: FETCH_ALBUM_CHAT_IMAGE_FAILED,
    error,
  }
}

export const FETCH_ALBUM_CHAT_FILE = "FETCH_ALBUM_CHAT_FILE"
export const FETCH_ALBUM_CHAT_FILE_REQUESTED = "FETCH_ALBUM_CHAT_FILE_REQUESTED"
export const FETCH_ALBUM_CHAT_FILE_COMPLETED = "FETCH_ALBUM_CHAT_FILE_COMPLETED"
export const FETCH_ALBUM_CHAT_FILE_FAILED = "FETCH_ALBUM_CHAT_FILE_FAILED"

export function fetchAlbumChatFileRequested() {
  return {
    type: FETCH_ALBUM_CHAT_FILE_REQUESTED
  }
}

export function fetchAlbumChatFile(chat_room_id, file_type, offset) {
  return function(dispatch) {
    dispatch(fetchAlbumChatFileRequested())
    return api.get(`/chat_rooms/${chat_room_id}/files`, { file_type, offset, length: FETCH_ALBUM_LENGTH })
        .then((results)=> {
          dispatch(fetchAlbumChatFileCompleted(results, file_type, offset))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchAlbumChatFileFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchAlbumChatFileCompleted(results, file_type, offset) {
  return {
    type: FETCH_ALBUM_CHAT_FILE_COMPLETED,
    results, file_type, offset,
  }
}

export function fetchAlbumChatFileFailed(error) {
  return {
    type: FETCH_ALBUM_CHAT_FILE_FAILED,
    error,
  }
}

export const FETCH_ALBUM_CHAT_VIDEO = "FETCH_ALBUM_CHAT_VIDEO"
export const FETCH_ALBUM_CHAT_VIDEO_REQUESTED = "FETCH_ALBUM_CHAT_VIDEO_REQUESTED"
export const FETCH_ALBUM_CHAT_VIDEO_COMPLETED = "FETCH_ALBUM_CHAT_VIDEO_COMPLETED"
export const FETCH_ALBUM_CHAT_VIDEO_FAILED = "FETCH_ALBUM_CHAT_VIDEO_FAILED"

export function fetchAlbumChatVideoRequested() {
  return {
    type: FETCH_ALBUM_CHAT_VIDEO_REQUESTED
  }
}

export function fetchAlbumChatVideo(chat_room_id, offset) {
  return function(dispatch) {
    dispatch(fetchAlbumChatVideoRequested())
    return api.get(`/chat_rooms/${chat_room_id}/videos`,{ offset, length: FETCH_ALBUM_LENGTH })
        .then((results)=> {
          dispatch(fetchAlbumChatVideoCompleted(results, offset))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchAlbumChatVideoFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchAlbumChatVideoCompleted(results, offset) {
  return {
    type: FETCH_ALBUM_CHAT_VIDEO_COMPLETED,
    results, offset,
  }
}

export function fetchAlbumChatVideoFailed(error) {
  return {
    type: FETCH_ALBUM_CHAT_VIDEO_FAILED,
    error,
  }
}

export const CLEAR_CHAT_ALBUM = "CLEAR_CHAT_ALBUM"

export function clearChatAlbum() {
  return {
    type: CLEAR_CHAT_ALBUM
  }
}

export const MAKE_CHAT_MESSAGE_READ = "MAKE_CHAT_MESSAGE_READ"
export const MAKE_CHAT_MESSAGE_READ_REQUESTED = "MAKE_CHAT_MESSAGE_READ_REQUESTED"
export const MAKE_CHAT_MESSAGE_READ_COMPLETED = "MAKE_CHAT_MESSAGE_READ_COMPLETED"
export const MAKE_CHAT_MESSAGE_READ_FAILED = "MAKE_CHAT_MESSAGE_READ_FAILED"

export function makeChatMessageReadRequested() {
  return {
    type: MAKE_CHAT_MESSAGE_READ_REQUESTED
  }
}

export function makeChatMessageRead(chat_room_id) {
  return function(dispatch) {
    dispatch(makeChatMessageReadRequested())
    return api.get(`/chat_rooms/${chat_room_id}/flush`)
        .then((results)=>{
          dispatch(makeChatMessageReadCompleted(results))
        })
        .catch((error)=> {
            Promise.all([
              dispatch(makeChatMessageReadFailed(error)),
              dispatch(emitAlertMessage(error, 'error'))
            ])
        })
  }
}

export function makeChatMessageReadCompleted(results) {
  return {
    type: MAKE_CHAT_MESSAGE_READ_COMPLETED,
    results,
  }
}

export function makeChatMessageReadFailed(error) {
  return {
    type: MAKE_CHAT_MESSAGE_READ_FAILED,
    error,
  }
}


// WEBPACK FOOTER //
// ./src/actions/chat-rooms.js